import { getStore } from '../store/store';
import type MailFavoritesViewState from '../store/schema/FavoritesViewState';

export default function getMailFavoritesViewState(
    accountKey: string
): MailFavoritesViewState | undefined {
    return getStore().mailFavoritesViewState.get(accountKey);
}
